import loanInfo from './loanInfo.vue';
export default loanInfo;


// WEBPACK FOOTER //
// ./src/staticComponents/loanInfo/index.js